import { createRouteRef } from '@backstage/frontend-plugin-api';

export const rootRouteRef = createRouteRef();
export const documentationRouteRef = createRouteRef();
export const usageAnalyticsRouteRef = createRouteRef();
